function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.9555 0H2.04453C0.917156 0 0 0.917188 0 2.04456V13.9555C0 15.0828 0.917156 16 2.04453 16H13.9555C15.0828 16 16 15.0828 16 13.9554V2.04456C16 0.917188 15.0828 0 13.9555 0ZM15.0576 13.9555C15.0576 14.5632 14.5632 15.0576 13.9555 15.0576H2.04453C1.43681 15.0576 0.942406 14.5632 0.942406 13.9555V12.2365L4.04413 9.59741C4.15731 9.50109 4.32244 9.50019 4.43669 9.59506L6.37962 11.2084C6.56697 11.364 6.84197 11.3512 7.01412 11.1789L11.6307 6.55531C11.7141 6.47172 11.8114 6.46359 11.8622 6.46619C11.9128 6.46878 12.0089 6.48684 12.0833 6.57856L15.0576 10.2408V13.9555H15.0576ZM12.8149 5.98434L15.0576 8.74578V2.04456C15.0576 1.43684 14.5632 0.942438 13.9555 0.942438H2.04453C1.43681 0.942438 0.942406 1.43684 0.942406 2.04456V10.9991L3.43341 8.87969C3.89622 8.48591 4.57134 8.48188 5.03881 8.87006L6.651 10.2088L10.9638 5.88938C11.213 5.63969 11.5583 5.50712 11.9104 5.52494C12.2628 5.54303 12.5925 5.71047 12.8149 5.98434Z",
  fill: "#333333"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.74316 4.26667C2.74316 3.00636 3.7685 1.98096 5.02888 1.98096C6.28925 1.98096 7.31459 3.00633 7.31459 4.26667C7.31459 5.52702 6.28922 6.55239 5.02888 6.55239C3.76853 6.55239 2.74316 5.52702 2.74316 4.26667ZM3.69114 4.26667C3.69114 5.00429 4.29123 5.60441 5.02888 5.60441C5.76653 5.60441 6.36662 5.00429 6.36662 4.26667C6.36662 3.52906 5.76653 2.92893 5.02888 2.92893C4.29123 2.92893 3.69114 3.52902 3.69114 4.26667Z",
  fill: "#333333"
});

var SvgImageIcon = function SvgImageIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImageIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Image_icon.033cd24a.svg";
export { ForwardRef as ReactComponent };